export type OnboardingLiveAuthSupplier = () => string;
export type OnboardingLiveAuthSource = string | OnboardingLiveAuthSupplier;

export type OnboardingHttpStatusError = {
	status?: unknown;
	response?: { status?: unknown };
};

export const toOnboardingLiveAuthSupplier = (
	source: OnboardingLiveAuthSource
): OnboardingLiveAuthSupplier => (typeof source === 'function' ? source : () => source);

export const getOnboardingHttpStatus = (error: unknown): number | null => {
	if (!error || typeof error !== 'object') return null;
	const candidate = error as OnboardingHttpStatusError;
	const rawStatus = candidate.status ?? candidate.response?.status;
	return typeof rawStatus === 'number' && Number.isInteger(rawStatus) ? rawStatus : null;
};

export const isOnboardingUnauthorizedError = (error: unknown): boolean =>
	getOnboardingHttpStatus(error) === 401;

const readRequiredToken = (getToken: OnboardingLiveAuthSupplier): string => {
	const token = String(getToken() ?? '').trim();
	if (!token) {
		throw Object.assign(new Error('Authoritative session is unavailable'), {
			status: 401,
			code: 'onboarding_auth_unavailable'
		});
	}
	return token;
};

/** Read authoritative authentication immediately before one exact request. */
export const runOnboardingLiveAuthStep = async <Result>(
	getToken: OnboardingLiveAuthSupplier,
	request: (token: string) => Promise<Result>
): Promise<Result> => await request(readRequiredToken(getToken));
